
import { mapActions } from 'vuex'
import { ESTADOS } from '../../_mock/uf.js'
export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      items: ESTADOS,
      loadingCnpj: false,
      btnCnpjSearch: false,
      rules: [(v) => !!v || 'Campo obrigatório'],
      telefoneRules: [
        (v) => !!v || 'O telefone é obrigatório',
        (v) => {
          const digits = (v || '').replace(/\D/g, '')
          return (
            digits.length === 10 ||
            digits.length === 11 ||
            'O telefone deve conter DDD e número válido'
          )
        },
      ],
      emailRules: [
        (v) => !!v || 'O e-mail é obrigatório',
        (v) => /.+@.+\..+/.test(v) || 'E-mail deve ser válido',
      ],
    }
  },

  watch: {
    'value.cpf_cnpj'(newCpfCnpj) {
      const cpfCnpjSemCaracters = newCpfCnpj.replace(/\D/g, '')
      this.btnCnpjSearch = cpfCnpjSemCaracters.length === 14
    },
  },

  methods: {
    ...mapActions('sdagenda', ['fetchCnpj']),
    async searchCnpj() {
      this.loadingCnpj = true
      const cpfCnpjSemCaracters = this.value.cpf_cnpj.replace(/\D/g, '')
      try {
        const data = await this.fetchCnpj(cpfCnpjSemCaracters)
        if (!data) {
          this.$toast.error('Não foi possível encontrar o CNPJ')
          return
        }

        const str = data.cnae_principal.split(' - ')
        const codigo = str[0]
        const descricao = str[1]

        this.value.cnaes_secundarios = data.cnae_secundario?.split(',') || []
        this.value.nome = data.razao
        this.value.endereco.cep = data.log_cep
        this.value.endereco.bairro = data.log_bairro
        this.value.endereco.rua = data.log_nome
        this.value.endereco.numero = data.log_num
        this.value.endereco.complemento = data.log_comp
        this.value.endereco.cidade = data.log_municipio
        this.value.endereco.uf = data.log_uf


        this.value.cnaes_principal = {
          codigo,
          descricao,
        }
      } catch (error) {
        const data = error.response?.data
        this.$toast.error('error: ' + data.error)
      } finally {
        this.loadingCnpj = false
      }
    },
  },
}
